import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SimpleSearchComponent } from "./components/simple-search/simple-search.component";

import { FormsModule } from "@angular/forms";
import { FormsModule as RubblFormsModule } from "../forms/forms.module";
import { HomeSearchComponent } from "./components/home-search/home-search.component";
import { CoreModule } from "../core/core";
import { SearchResultsNearbyLocationsComponent } from "./components/search-results-nearby-locations/search-results-nearby-locations.component";
import { RouterModule } from "@angular/router";

@NgModule({
  declarations: [SimpleSearchComponent, HomeSearchComponent, SearchResultsNearbyLocationsComponent],
  imports: [CommonModule, FormsModule, RubblFormsModule, CoreModule, RouterModule],
  exports: [SimpleSearchComponent, HomeSearchComponent, SearchResultsNearbyLocationsComponent],
})
export class SearchResultsModule {}
